module.exports = __webpack_public_path__ + "img/home_product_footpath.1297633d.jpg";